import { render, staticRenderFns } from "./LangBtn.vue?vue&type=template&id=78d28448"
import script from "./LangBtn.vue?vue&type=script&lang=js"
export * from "./LangBtn.vue?vue&type=script&lang=js"
import style0 from "./LangBtn.vue?vue&type=style&index=0&id=78d28448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports